<template>
  <div>
    <SearchHeader title='Versions' icon='cubes' prompt='Search for a version by providing a name, description, or other identifying details.' @change='search'/>
    <SearchResults v-if='searchText || versions.length > 0' :data='versions && Array.isArray(versions) ? versions : []' className='version' :fields='tableFields' :actions='tableActions ? tableActions : []' :dataActions='tableDataActions  ? tableDataActions : []' @clickAction='handleAction'/>
    <b-row v-if='canCreateVersion()'>
      <b-col>
        <b-button size='xs' variant='primary' @click='addSinature()'>Add Version</b-button>
      </b-col>
    </b-row>
    <DeleteRecordModal ref='deleteModal' className='version' :id='deleteId' @deleted='search(searchText)'/>
    <TabbedModal v-if='versions[selectedVersionIndex]' id='version_modal' :visible='showVersionModal' @change='handleHideModal' title='Manage Version' @input='setSelectedTab'>
      <Tab title='Details'>
        <Form @submit="handleSubmit" id='version-form' :saveVisibleOverride='canUpdateVersion()'>
          <VersionEdit ref='version' @UpdateVersion='UpdateVersion' :version="versions[selectedVersionIndex]" @entrypoint_wait_show='$emit("entrypoint_wait_show", $event)' @entrypoint_wait_hide='$emit("entrypoint_wait_hide")'/>
        </Form>
      </Tab>
    </TabbedModal>
  </div>
</template>

<script>
  import abilityTester from '@/config/abilityTester';
  import DeleteRecordModal from '@/components/modal/DeleteRecord';
  import Form from '@/components/form/Form';
  import { mapMutations } from 'vuex';
  import {ADD_ERROR} from '@/store/MutationTypes';
  import rest from '@/common/tools/Rest';
  import TabbedModal from '@/components/modal/TabbedModal';
  import Tab from '@/components/elements/tabs/Tab';
  import SearchHeader from '@/components/search/Header';
  import SearchResults from '@/components/search/Results';
  import VersionEdit from '@/components/version/Edit';

  export default {
    name: 'VersionList',
    components: {
      DeleteRecordModal,
      Form,
      TabbedModal,
      Tab,
      SearchHeader,
      SearchResults,
      VersionEdit,
    },
    computed: {
      selectedVersionId(){
        return this.versions[this.selectedVersionIndex] && this.versions[this.selectedVersionIndex].id ? this.versions[this.selectedVersionIndex].id : '';
      },
      selectedVersionIsNew() {
        return  this.selectedVersionId ? false : true
      },
      showVersionModal() {
        return this.versions[this.selectedVersionIndex] ? true : false;
      },
      tableDataActions() {
        var resp = [];
        for(var i in this.versions){
          var actions = [];
          actions.push('view');
          if(this.canDeleteVersion(this.versions[i].id)){
            actions.push('delete');
          }
          resp.push(actions);
        }
        return resp;
      }
    },
    data() {
      return {
        deleteId: '',
        searchText: '',
        selectedVersionIndex: null,
        selectedTab: null,
        tableActions: {
          delete: {title: 'Delete', icon: 'times'},
          view: {title: 'View', icon: 'edit'}
        },
        tableFields: [
          {key: 'description', displayStatus: true},
          {key: 'Action', class: 'text-center'}
        ],
        versions: []
      }
    },
    methods: {
      ...mapMutations('messages', {
        error: ADD_ERROR
      }),
      addVersion(){
        var newVersion = {};
        var i = this.versions.push(newVersion) - 1;
        this.displayVersionModal(i);
      },
      canCreateVersion(){
        return abilityTester.can('create', 'version');
      },
      canDeleteVersion(id){
        return abilityTester.can('delete', 'version', {version_id: id});
      },
      canUpdateVersion(){
        return this.$refs.version ? this.$refs.version.canUpdateVersion() : VersionEdit.methods.canUpdate(this.versions[this.selectedVersionIndex]);
      },
      displayDeleteModal(id){
        this.deleteId = id;
        this.$refs.deleteModal.show();
      },
      displayVersionModal(index){
        this.selectedVersionIndex = index;
      },
      handleAction(action, item, index){
        switch(action){
          case 'delete':
            this.displayDeleteModal(item.id);
            break;
          case 'view':
            this.displayVersionModal(index);
            break;
        }

      },
      handleHideModal(show){
        if(!show){
          this.selectedVersionIndex = null;
          this.setSelectedTab(0);
        }
      },
      handleSubmit(){
        this.$refs.version.save();
      },
      search(text){
        if(text.length === 0){
          this.searchText = '';
          this.versions = [];
          return;
        }
        this.selectedVersionIndex = null;
        this.searchText = text;
        var args = {
          'loading': 'Products',
        }
        this.$emit('entrypoint_wait_show', 'Searching...');
        rest.get('version/search/' + text, 'version', args).then(versions => {
          this.versions = Array.isArray(versions) ? versions : [];
        }).catch(e => {
          this.error(rest.getErrorMessage(e));
        }).finally(() => {
            this.$emit('entrypoint_wait_hide');
          })
      },
      UpdateVersion(version) {
        this.versions[this.selectedVersionIndex] = version;
        this.$refs.version.$forceUpdate();
      },
      setSelectedTab(value){
        this.selectedTab = value;
      },
    }
  }
</script>

<style scoped>
</style>
